import type { LicenseType } from '../LicenseRequestForm';
import { LicenseTypes } from '../LicenseRequestForm';
import type { PONumberValues } from '../LicenseRequestForm';

/**
 * Build our field rules for form
 */
export const getRules = (localState: Object) => {
  const licenseType: LicenseType = localState.licenseType;
  const poNumberRadioValue: PONumberValues = localState.poNumberRadioValue;

  const rules = {
    'chooseAccount.tradingAccount': 'required',
    'chooseLicense.type': 'required',
    licenseDetails: 'required',
    'licenseDetails.manufacturer': 'required',
    'licenseDetails.product': 'required',
    'requiredDate.date': 'required|date',
  };

  if (
    licenseType === LicenseTypes.TRANSFER_EXISTING_LICENSE ||
    licenseType === LicenseTypes.REMOVE_CURRENT_LICENSE
  ) {
    rules['assetDetails.assetNumber'] = 'required';
    rules['assetDetails.serialNumber'] = 'required';
  }

  if (
    licenseType === LicenseTypes.REQUEST_NEW_LICENSE ||
    licenseType === LicenseTypes.TRANSFER_EXISTING_LICENSE
  ) {
    rules['newAssetDetails.assetNumber'] = 'required';
    rules['newAssetDetails.serialNumber'] = 'required';
  }

  if (licenseType === LicenseTypes.REMOVE_CURRENT_LICENSE) {
    rules['newAssetDetails.assetNumber'] = '';
    rules['newAssetDetails.serialNumber'] = '';
    rules['assetDetails.returnKeyCode'] = 'required';
  } else {
    rules['assetDetails.returnKeyCode'] = '';
  }

  if (poNumberRadioValue === 'use_new') {
    rules['poNumber.number'] = 'required';
  } else {
    rules['poNumber.number'] = '';
  }

  if (licenseType === LicenseTypes.REQUEST_NEW_LICENSE) {
    rules['assetDetails.assetNumber'] = '';
    rules['assetDetails.serialNumber'] = '';
  }

  return rules;
};
